import {CircularProgress, PassportUser, PassportUserLocale, useMediaQuery} from '@logistics-frontend/blocks/legacy'
import {theme} from '@logistics-frontend/blocks/lpc/theme'
import {useI18n} from '@logistics-frontend/core/i18n'
import {AsyncStatus} from '@yandex-taxi/react-integration-api'
import React from 'react'

import {useClasses} from './classes'
import {usePassportRequest} from './hooks'

const User: React.FC = () => {
  const classes = useClasses()
  const t = useI18n()
  const {data: props, status} = usePassportRequest()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  const i18nLocale: PassportUserLocale = {
    addUser: t('passport.user.adduser', 'Добавить пользователя'),
    error: t('passport.user.error', 'Ошибка'),
    signin: t('passport.user.signin', 'Войти'),
    signout: t('passport.user.signout', 'Выйти'),
  }

  if (status === AsyncStatus.PENDING) {
    return <CircularProgress size={20} />
  }

  if (status === AsyncStatus.SUCCESS && props) {
    return <PassportUser className={classes.root} mobile={matches} {...props} locale={i18nLocale} />
  }

  return null
}

export default User
